import '../libs/slick.js';
import HandleVideoOutSite from './HandleVideoOutSite.js';

const handleVideo = new HandleVideoOutSite();
export default class CommonSlider {
  constructor(el) {
    this.$this = $(el);
    this.$wrapArrowSlider = this.$this.find('.wrap-arrow-slider');
    this.$slider = this.$this.find('.slider');
  }

  init() {
    this.addSlick()

    this.$slider.on('reInitSlider', () => {
      this.$slider.slick('unslick')
      this.addSlick()
    })
  }

  addSlick() {
    this.$slider.on('init', () => {
      this.$slider.addClass('slick-loaded')
    })
    this.$slider.slick({
      slide: '.slider-item',
      rows: 0,
      autoplay: this.$this.hasClass('auto-slide-ten-se'),
      autoplaySpeed: 10000,
      infinite: !!this.$this.hasClass('has-loop'),
      arrows: true,
      dots: !!this.$this.hasClass('has-dots'),
      prevArrow: `<button class="slick-prev arrows text-white"><span class="icomoon ${this.$this.hasClass('arrow-v2') ? 'icon-arrow_forward-left' : 'icon-arrow-left-alt'}"></span><span class="sr-only">Prev slider</span></button>`,
      nextArrow: `<button class="slick-next arrows text-white"><span class="icomoon ${this.$this.hasClass('arrow-v2') ? 'icon-arrow_forward-right' : 'icon-arrow-right-alt'}"></span><span class="sr-only">Next slider</span></button>`,
      appendArrows: this.$wrapArrowSlider.length ? this.$wrapArrowSlider : undefined,
    })
    this.$slider.on('beforeChange', () => {
      const $slickActive = this.$slider.find('.slick-active')
      if ($slickActive.hasClass('js-background-video')) {
        handleVideo.checkHandlePauseVideo($slickActive.find('iframe'), $slickActive.find('video'))
      }
    })
    this.$slider.on('afterChange', () => {
      const $slickActive = this.$slider.find('.slick-active')
      if ($slickActive.hasClass('js-background-video') && !$slickActive.find('.btn-play-pause').hasClass('active-pause')) {
        handleVideo.checkHandlePlayVideo($slickActive.find('iframe'), $slickActive.find('video'))
      }
    })
  }
}

$('.common-slider').each((_index, el) => {
  new CommonSlider(el).init()
})
